// extracted by mini-css-extract-plugin
export default {"submit":"styles_submit__TyAoe","spinner":"styles_spinner__MkrcU"};